import { fetchApi } from "~/lib/api";
import type { NameValidationResponse } from "~/types";

export const nameValidationService = {
  /**
   * Validate a Romanian name and get diacritic suggestions
   */
  async validateName(name: string): Promise<NameValidationResponse> {
    return fetchApi<NameValidationResponse>("/anonymous/name-validation", {
      method: "POST",
      body: JSON.stringify({ name }),
    });
  },
};
